import { DataBean } from "../DataBean";

export class IncomeResponsibleConcept extends DataBean {


    public async getIncomeResponsibleConceptCatalog(idIncomeResponsible:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getIncomeResponsibleConceptCatalog_Number", [idIncomeResponsible]);
    }

  
    

 
}